import React from 'react';
import { TagV2, TagV2Variant, TagV2Size } from '@zola/zola-ui/src/components/Tag/TagV2';

const MatchThemeTag = ({ className }: { className?: string }): JSX.Element => (
  <TagV2
    variant={TagV2Variant.WHITE}
    size={TagV2Size.LARGE}
    emoji={{ symbol: '⭐️', alt: 'star emoji' }}
    className={className}
  >
    Matches Your Website
  </TagV2>
);

export default MatchThemeTag;
